import { logger } from '../../../../utils/logger';
import { cxoneSdkState } from '../../state';

export async function preGatherICECandidates(iceUrls?: string[]): Promise<void> {
  logger.debug('[CXone SDK] Pre-gathering ICE candidates...');

  try {
    const config: RTCConfiguration = {
      iceServers: iceUrls?.length
        ? iceUrls.map((url) => ({ urls: url }))
        : [{ urls: 'stun:stun.l.google.com:19302' }],
    };

    const pc = new RTCPeerConnection(config);

    if (cxoneSdkState.preWarmedMediaStream) {
      const tracks = cxoneSdkState.preWarmedMediaStream.getAudioTracks();
      if (tracks.length > 0) {
        pc.addTrack(tracks[0], cxoneSdkState.preWarmedMediaStream);
      }
    } else {
      const ctx = new AudioContext();
      const oscillator = ctx.createOscillator();
      const dest = ctx.createMediaStreamDestination();
      oscillator.connect(dest);
      oscillator.start();
      const silentStream = dest.stream;
      const silentTrack = silentStream.getAudioTracks()[0];
      pc.addTrack(silentTrack, silentStream);
      oscillator.stop();
      ctx.close();
    }

    const offer = await pc.createOffer();
    await pc.setLocalDescription(offer);

    await new Promise<void>((resolve) => {
      if (pc.iceGatheringState === 'complete') {
        resolve();
        return;
      }

      const checkState = () => {
        if (pc.iceGatheringState === 'complete') {
          resolve();
        }
      };

      pc.onicegatheringstatechange = checkState;
      setTimeout(() => resolve(), 2000);
    });

    logger.debug(
      '[CXone SDK] ICE candidates pre-gathered, gathered',
      pc.localDescription?.sdp?.match(/a=candidate/g)?.length || 0,
      'candidates'
    );

    pc.close();
  } catch (error) {
    logger.warn('[CXone SDK] Failed to pre-gather ICE candidates:', error);
  }
}
